import { render, staticRenderFns } from "./PageHeadBar.vue?vue&type=template&id=497fff0f&scoped=true&"
import script from "./PageHeadBar.vue?vue&type=script&lang=js&"
export * from "./PageHeadBar.vue?vue&type=script&lang=js&"
import style0 from "./PageHeadBar.vue?vue&type=style&index=0&id=497fff0f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "497fff0f",
  null
  
)

export default component.exports